{
  "name": "@m3s/smart-contract",
  "version": "1.9.2",
  "type": "module",
  "description": "A modular toolkit for generating, compiling, deploying, and interacting with Ethereum-compatible smart contracts",
  "license": "MIT",
  "keywords": [
    "smart-contract",
    "ethereum",
    "erc20",
    "erc721",
    "erc1155",
    "solidity",
    "blockchain",
    "web3",
    "openzeppelin"
  ],
  "repository": {
    "type": "git",
    "url": "git@bitbucket.org:ctb-marisca/ms3-package.git",
    "directory": "packages/smart-contract"
  },
  "main": "./dist/index.cjs.js",
  "module": "./dist/index.esm.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.esm.js",
      "require": "./dist/index.cjs.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "tsc -b",
    "test": "vitest run --sequence.sequential",
    "test:core": "vitest run 01_Core.test.ts 02_IBaseContractHandler.test.ts",
    "test:erc20": "vitest run 03_ERC20.test.ts",
    "test:erc721": "vitest run 04_ERC721.test.ts",
    "test:erc1155": "vitest run 05_ERC1155.test.ts"
  },
  "dependencies": {
    "@m3s/wallet": "^2.0.4",
    "@openzeppelin/contracts": "^5.2.0",
    "@openzeppelin/contracts-upgradeable": "^5.0.0",
    "@openzeppelin/wizard": "^0.5.3",
    "@openzeppelin/wizard-cairo": "^1.0.0",
    "@openzeppelin/wizard-stellar": "^0.1.1",
    "@openzeppelin/wizard-stylus": "^0.2.0-alpha.4",
    "ethers": "^6.13.5",
    "hardhat": "^2.22.19",
    "joi": "^17.13.3",
    "starknet": "^6.24.1"
  },
  "devDependencies": {
    "@m3s/common": "*"
  },
  "publishConfig": {
    "access": "public",
    "tag": "latest"
  },
  "files": [
    "dist",
    "README.md"
  ]
}
